/**
 * 数字员工 Hub 菜单显隐配置（构建期由 .env 注入）
 *
 * VUE_APP_ENABLE_QUICK_ECOM_MENU=true  → 强制显示「快捷出图」
 * VUE_APP_ENABLE_QUICK_ECOM_MENU=false → 强制隐藏
 * 未配置时：development 显示，production 打包隐藏
 */

export function isQuickEcomMenuEnabled() {
  const flag = String(process.env.VUE_APP_ENABLE_QUICK_ECOM_MENU || '').trim().toLowerCase()
  if (flag === 'true' || flag === '1') return true
  if (flag === 'false' || flag === '0') return false
  return process.env.NODE_ENV !== 'production'
}

export function isQuickVideoMenuEnabled() {
  const flag = String(process.env.VUE_APP_ENABLE_QUICK_VIDEO_MENU || '').trim().toLowerCase()
  if (flag === 'true' || flag === '1') return true
  if (flag === 'false' || flag === '0') return false
  return process.env.NODE_ENV !== 'production'
}

/** 菜单模块开关（新增未开发模块可在此扩展） */
export const DE_MENU_FLAGS = {
  quickEcom: isQuickEcomMenuEnabled(),
  quickVideo: isQuickVideoMenuEnabled(),
}
